/* eslint-disable */
/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Regenerate via src/api/scripts/generator.sh */
/* generator-hash: 98ec97d12e36dc07c5260803ccbab79c1470e5af89c4fe875503ba3c1a1247b1 */
import { emptySplitApi as api } from '../emptyApi'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMergeFieldFields: build.query<
      GetMergeFieldFieldsApiResponse,
      GetMergeFieldFieldsApiArg
    >({
      query: (queryArg) => ({
        url: `/mergefield/MergeField/fields`,
        headers: {},
      }),
    }),
    postMergeField: build.mutation<
      PostMergeFieldApiResponse,
      PostMergeFieldApiArg
    >({
      query: (queryArg) => ({
        url: `/mergefield/MergeField`,
        method: 'POST',
        body: queryArg.mergeFieldRequestModel,
        headers: {},
      }),
    }),
    postMergeFieldValidationstatus: build.mutation<
      PostMergeFieldValidationstatusApiResponse,
      PostMergeFieldValidationstatusApiArg
    >({
      query: (queryArg) => ({
        url: `/mergefield/MergeField/validationstatus`,
        method: 'POST',
        body: queryArg.mergeFieldRequestModel,
        headers: {},
      }),
    }),
    getTerminology: build.query<
      GetTerminologyApiResponse,
      GetTerminologyApiArg
    >({
      query: (queryArg) => ({
        url: `/mergefield/Terminology`,
        headers: {},
        params: {
          clientId: queryArg.clientId,
          useLowercaseKeys: queryArg.useLowercaseKeys,
        },
      }),
    }),
    getMergeFieldFieldsCategoryByCategory: build.query<
      GetMergeFieldFieldsCategoryByCategoryApiResponse,
      GetMergeFieldFieldsCategoryByCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/mergefield/MergeField/fields/category/${queryArg.category}`,
        headers: {},
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as mergefield }
export type GetMergeFieldFieldsApiResponse = /** status 200 OK */ DemoModel
export type GetMergeFieldFieldsApiArg = {}
export type PostMergeFieldApiResponse = /** status 200 OK */ string
export type PostMergeFieldApiArg = {
  mergeFieldRequestModel: MergeFieldRequestModel
}
export type PostMergeFieldValidationstatusApiResponse =
  /** status 200 OK */ string
export type PostMergeFieldValidationstatusApiArg = {
  mergeFieldRequestModel: MergeFieldRequestModel
}
export type GetTerminologyApiResponse =
  /** status 200 OK */ BegrepsbankResponseModel
export type GetTerminologyApiArg = {
  /** The client id to get data for */
  clientId?: string
  /** True to make all terminology keys lowercase. Default is false. */
  useLowercaseKeys?: boolean
}
export type GetMergeFieldFieldsCategoryByCategoryApiResponse =
  /** status 200 OK */ MergeFieldModelRead[]
export type GetMergeFieldFieldsCategoryByCategoryApiArg = {
  /** Category name (case-insensitive) */
  category: string
}
export type DemoModel = {
  /** Describe the prop */
  thisIsATest?: string | null
}
export type ProblemDetails = {
  type?: string | null
  title?: string | null
  status?: number | null
  detail?: string | null
  instance?: string | null
  [key: string]: any
}
export type BblErrorModel = {
  /** What went wrong */
  message?: string | null
  /** Stacktrace */
  stackTrace?: string | null
}
export type MergeFieldRequestModel = {
  /** Text with variables */
  text?: string | null
  /** False (default) returns merged values as is (raw) where merge field codes have double curly brackets. True to html encode the merged values. */
  useHtmlEncodingForFieldsInDoubleCurlies?: boolean
  /** False (default) returns merged values as is (raw) where merge field codes have hash signs. True to html encode the merged values. */
  useHtmlEncodingForFieldsInHashSigns?: boolean
  /** False (default) returns merged values as is (raw) when merged value contains html formatting. True to html encode the merged values. */
  useHtmlEncodingForValuesContainingHtml?: boolean
  /** Allow invalid merge fields in the input text. If false (default), an exception will be thrown if the input text contains merge field codes that are not recognized or cannot be resolved. If true, unrecognized merge field codes will be left as is in the output text, without throwing an exception. */
  allowInvalidMergefields?: boolean
  /** Client id */
  clientId?: string | null
  /** Accounting year */
  accountingYear?: number | null
  /** AgreementId */
  agreementId?: string | null
  /** Meeting id (general assembly) */
  meetingId?: string | null
  /** Document template id */
  documentTemplateId?: string | null
  /** Document id */
  documentId?: string | null
  /** Ehf invoice header id */
  ehfInvoiceHeaderId?: string | null
  /** True to use board portal access rules. False (default) to use My Page access rules. Currently only used for calls against ms-insurance. */
  isBoardPortal?: boolean
}
export type BegrepsbankResponseModel = {
  /** Key value list with terminology (begrepsbank) */
  terminology?: {
    [key: string]: string | null
  } | null
}
export type MergeFieldModel = {
  /** Id of mergefield */
  id?: string | null
  /** Name of mergefield */
  name?: string | null
  /** Description of mergefield */
  description?: string | null
}
export type MergeFieldModelRead = {
  /** Id of mergefield */
  id?: string | null
  /** Name of mergefield */
  name?: string | null
  /** Description of mergefield */
  description?: string | null
  /** Mergefield code/variable name to use in document */
  code?: string | null
  /** Mergefield code/variable name to use in document */
  oldCode?: string | null
}
export const {
  useGetMergeFieldFieldsQuery,
  usePostMergeFieldMutation,
  usePostMergeFieldValidationstatusMutation,
  useGetTerminologyQuery,
  useGetMergeFieldFieldsCategoryByCategoryQuery,
} = injectedRtkApi
